import React, { useState } from "react";
import { ReactComponent as FilterIcon } from "../../../../assets/icons/modal/filter.svg";
import {
  clientTypeFilterSelector,
  phoneOrderStatusFilterSelector,
} from "../../../../utils/createSelector";
import DateRangeInputs from "../../../inputs/DateRangeInputs/DateRangeInputs";
import DefaultModal from "../../DefaultModal/DefaultModal";
import ModalBottomButtons from "../../forms/buttons/ModakBottomButtons/ModalBottomButtons";
import SelectInput, {
  SelectOption,
} from "../../forms/inputs/SelectInput/SelectInput";
import ModalTitle from "../../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: (
    type: SelectOption,
    status: SelectOption,
    startDate: Date | null,
    endDate: Date | null
  ) => void;
  defaultType: SelectOption;
  defultPaymentStatus: SelectOption;
  defaultStartDate: Date | null;
  defaultEndDate: Date | null;
}

const PhoneOrderFilterModal: React.FC<Props> = (props) => {
  const [type, setType] = useState<SelectOption>(
    props.defaultType || {
      value: "none",
      label: "All",
    }
  );
  const [status, setStatus] = useState<SelectOption>(
    props.defultPaymentStatus || {
      value: "none",
      label: "All",
    }
  );
  const [startDate, setStartDate] = useState<Date | null>(
    props.defaultStartDate
  );
  const [endDate, setEndDate] = useState<Date | null>(props.defaultEndDate);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          title="Filter"
          subTitle="Choose your filter parameters"
          onClose={props.onClose}
        >
          <FilterIcon />
        </ModalTitle>
        <div className={styles.form}>
          <SelectInput
            title="Type"
            value={type}
            values={clientTypeFilterSelector}
            onChange={(value) => setType(value)}
          />
          <SelectInput
            title="Status"
            value={status}
            values={phoneOrderStatusFilterSelector}
            onChange={(value) => setStatus(value)}
          />
          <DateRangeInputs
            start={startDate}
            onChangeStart={(value) => setStartDate(value)}
            end={endDate}
            onChangeEnd={(value) => setEndDate(value)}
          />
        </div>
        <ModalBottomButtons
          onPressApply={() => {
            props.onApply(type, status, startDate, endDate);
            props.onClose();
          }}
          onPressBack={props.onClose}
          backTitle="Back"
          applyTitle="Apply"
        />
      </div>
    </DefaultModal>
  );
};

export default PhoneOrderFilterModal;
